
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import GenericError from '@/components/common/Alerts/GenericError.vue';
import { setAutopay } from '@/api/loan';
import { AutopayDetails } from '@/interfaces/loan';
import { PaymentProviderBankDetails } from '@/interfaces/bank-account';
import { PaymentProviderCardDetails } from '@/interfaces/moov';
import { PaymentOptions } from '@/interfaces/payment-options';
import applicationId from '@/filters/application-id';

export default defineComponent({
  name: 'ConfirmCancelAutopayDialog',

  components: {
    CustomButton,
    CustomDialog,
    GenericError
  },

  data() {
    return {
      loading: false,
      showError: false,
    };
  },

  computed: {
    autopayDetails(): AutopayDetails {
      return this.$store.getters['Loan/getAutopayDetails'];
    },

    bankAccount(): PaymentProviderBankDetails {
      return this.$store.getters['PaymentOptions/getBankAccount'];
    },

    card(): PaymentProviderCardDetails {
      return this.$store.getters['PaymentOptions/getCard'];
    },

    paymentOptionBank() {
      return this.autopayDetails.payment_method_details.payment_method_type
      === PaymentOptions.BANK;
    },

    loan() {
      return applicationId(this.$store.getters['User/activeLoanNumber']);
    },
  },

  methods: {
    async cancelAutopay() {
      this.showError = false;
      this.loading = true;
      const paymentDetails = this.autopayDetails;
      try {
        await setAutopay({
          recurring_payments: false,
          payment_provider_details: this.paymentOptionBank
            ? this.bankAccount.payment_provider_details_id
            : this.card.payment_provider_details_id,
          payment_provider_option_id: paymentDetails.payment_provider_option_id,
          payment_provider_option_type: paymentDetails.payment_method_details.payment_method_type
        });
        this.$alerts.add({
          type: GlobalAlertTypes.SUCCESS,
          timed: true,
          text: `You have successfully cancelled your Autopay for Loan ${this.loan}`
        });

        this.$store.dispatch('Loan/getAutopayInfo');
        this.$emit('close');
      } catch {
        this.showError = true;
      } finally {
        this.loading = false;
      }
    }
  }
});
